import {
  VStack,
  Center,
  Text,
  Spacer,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Spinner,
} from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useCallback, useState } from "react";
import { passwordChangeVerify } from "./SessionApi";
import { ofiEmail } from "../Components/foreningen";
import { KeyIcon } from "lucide-react";

export function PasswordChangeVerification() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  const [
    passwordVerificationErrorMessage,
    setPasswordVerificationErrorMessage,
  ] = useState<string | null>(null);
  const [waitingForResponse, setWaitingForResponse] = useState(false);
  const [responseReceived, setResponseReceived] = useState(false);
  const [verified, setVerified] = useState(false);
  const [password, setPassword] = useState("");

  const triggerVerification = useCallback(
    async (password: string) => {
      if (code) {
        setWaitingForResponse(true);
        passwordChangeVerify(code, password)
          .then((r) => {
            setVerified(true);
            setResponseReceived(true);
          })
          .catch((e: any) => {
            setVerified(false);
            if (e.response?.status === 401 || e.response?.status === 403) {
              //TODO: sleep 2 seconds
              setPasswordVerificationErrorMessage("Fel lösenord, försök igen!");
            } else {
              console.error("Other error:", e);
              setResponseReceived(true);
            }
          })
          .finally(() => {
            setWaitingForResponse(false);
          });
      }
    },
    [code, setVerified, setResponseReceived, setPassword]
  );

  if (code == null || code == "") {
    return (
      <VStack spacing={"3"}>
        <Text fontSize={"30px"}>Verifieringskod saknas</Text>
      </VStack>
    );
  } else if (!responseReceived) {
    return (
      <VStack spacing={"3"}>
        <Center>
          <Text fontSize={"40px"}>Byt lösenord</Text>
        </Center>

        <Text fontSize={"20px"} margin={"30px"} textAlign={"left"}>
          Verifiera lösenordet du vill byta till!
        </Text>

        <HStack>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <KeyIcon color="yellow" opacity={"80%"} />
            </InputLeftElement>
            <Input
              placeholder="Lösenord"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputGroup>
          <Button
            rightIcon={waitingForResponse ? <Spinner /> : undefined}
            margin={"20px"}
            minWidth={"100px"}
            colorScheme="blue"
            isDisabled={waitingForResponse || (password?.length ?? 0) < 4}
            onClick={() => {
              if (waitingForResponse || (password?.length ?? 0) >= 4) {
                triggerVerification(password);
              } else {
                console.log("Disabled verify button");
              }
            }}
          >
            Slutför
          </Button>
        </HStack>

        {passwordVerificationErrorMessage && (
          <Text textColor={"red"} fontWeight={"bold"} textStyle={"italic"}>
            {passwordVerificationErrorMessage}
          </Text>
        )}
      </VStack>
    );
  } else if (!verified) {
    return (
      <VStack>
        <Center>
          <Text fontSize={"40px"}>Byte av lösenord misslyckades!</Text>
        </Center>
        <Text fontSize={"20px"}>
          Du är välkommen att försöka igen. Om felet kvarstår så kan du höra av
          dig till {ofiEmail} för hjälp.
        </Text>
      </VStack>
    );
  }

  return (
    <VStack spacing={"3"} width={"100%"} textAlign={"left"}>
      <Center>
        <Text fontSize={"40px"}>Ditt lösenord är uppdaterat!</Text>
      </Center>
    </VStack>
  );
}
